<template>
  <div id="container">
    <menubar from="huashuEdit"/>
    <div v-if="isElectron" class="top" :style="{'position':'fixed'}">
      <div class="topL">
      </div>
      <!-- <div class="cancelBtn" @click="cancelbtnClick">取消</div> -->
      <div  class="saveBtn" :class="{'saveBtnSaving': saving}" @click="savebtnClick">保存</div>
    </div>
    <div class="topTitle">添加/编辑话术</div>
    <div v-if="isWeb" :style="{'display':'flex','align-items':'center','justify-content':'space-between'}">
      <div :style="{'margin-left':'24px'}">话术标题</div>
      <div v-if="isWeb" class="bottomBarL">
        <div class="optionTitle">发送时是否带标题</div>
        <div class="optionItem" @click="()=>{this.isCarryTitle=!this.isCarryTitle}">
          <img v-if="!isCarryTitle" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
          <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
          <div>带</div>
        </div>
        <div class="optionItem optionItem2" @click="()=>{this.isCarryTitle=!this.isCarryTitle}">
          <img v-if="isCarryTitle" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
          <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
          <div>不带</div>
        </div>
      </div>
    </div>
    <input v-if="isWeb" class="title2" v-model="title" />
    <input v-else class="title" placeholder="标题（选填）" v-model="title" />
    <div v-if="isWeb" class="title3">话术内容</div>
    <textarea v-if="false" ref="textarea" class="content" :style="{'width':isWeb?'94%':'calc(94.87vw - 16px)'}" placeholder="输入内容" v-model="content" @blur="onBlur"></textarea>
     <!-- <textarea ref="textarea" class="content" :style="{'width':isWeb?'94%':'calc(94.87vw - 16px)'}" placeholder="输入内容" v-model="content" @blur="onBlur"></textarea> -->
    <div class="content2 no-drag" contenteditable="true" id="contentEditor" ref="contentEditor" @click="contentEditorClick" @blur="onBlur">
      <br>
    </div>
    <div class="bottomBar">
      <div v-if="!editHuashuData" class="bottomBarL">
        <div class="optionTitle">排序：</div>
        <div :style="{display:'flex',width:'240px'}">
          <div class="optionItem" @click="changeFront(1)">
            <img v-if="isFront==2" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
            <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
            <div v-if="isTop">排在<span>(置顶)</span>最前</div>
            <div v-else>排在最前</div>
          </div>
          <div class="optionItem optionItem2" @click="changeFront(2)">
            <img v-if="isFront==1" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
            <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
            <div v-if="isTop">排在<span>(置顶)</span>最后</div>
            <div v-else>排在最后</div>
          </div>
        </div>
         <el-checkbox class="topCheckbox" v-model="isTop">置顶</el-checkbox>
      </div>
      <div v-if="!isWeb" class="bottomBarL">
        <div class="optionTitle">发送时是否带标题</div>
        <div class="optionItem" @click="()=>{this.isCarryTitle=!this.isCarryTitle}">
          <img v-if="!isCarryTitle" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
          <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
          <div>带</div>
        </div>
        <div class="optionItem optionItem2" @click="()=>{this.isCarryTitle=!this.isCarryTitle}">
          <img v-if="isCarryTitle" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
          <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
          <div>不带</div>
        </div>
      </div>
      <div class="bottomBarR">
        <div class="addLink" @click="addMediaBtnClick">
          <img src="https://imagessl.edujia.com/A-1ed71af7_20230825152336.png" />图片/视频/文件
        </div>
        <div class="addLink" @click="insertPartSimbol">插入强制分段符</div>
        <div class="faceBtn" @click="faceBtnClick"><div>&#128515</div><div class="faceBtnlbl">表情</div></div>
        <!-- <div class="saveBtn" @click="savebtnClick">保存</div> -->
      </div>
    </div>
    <div v-if="isWeb">
      <div v-for="(item,idx) in fileList" :key="'fileListItem'+idx" class="itemP">
        <div v-if="item.file.type.includes('video')" class="videoPoster" :id="'video'+item.newImportIdx">
          <div class="videoPosterT">
            <img class="videoIcon" src="https://imagessl.edujia.com/A-1ed71af7_20231013134229.png">
            <div class="videoItemVideo"
              :style="`background: url(`+item.videoInfo.poster+`)center center / cover no-repeat;`"></div>
          </div>
          <div class="videoPosterB">
            <div class="videoPosterBL" :id="'videoQr'+item.newImportIdx"></div>
            <div class="videoPosterBR">
              <div class="videoPosterBRT">扫一扫看视频</div>
              <div class="videoPosterBRB">视频时长{{$common.ts2timeDay(item.videoInfo.duration*1000)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="list">
      <div v-for="(item,idx) in fileList" :key="'fileListItem'+idx" class="itemP">
        <img class="itemClose" src="https://imagessl.edujia.com/A-1ed71af7_20231011175157.png" @click="delClick(idx)" />
        <img v-if="item.fileType=='img'&&item.path" class="imgItem item" :src="item.path" />
        <img v-else-if="item.fileType=='img'&&item.url" class="imgItem item" :src="item.url" />
        <div v-else-if="item.fileType=='video'" class="videoItem item">
          <img class="miniVideoIcon videoIcon" src="https://imagessl.edujia.com/A-1ed71af7_20231013134229.png">
          <img :src="item.videoInfo.poster">
        </div>
        <div v-else class="fileItem item">
          <img :src="item.icon" />
          <div v-if="item.file.name">{{item.file.name}}</div>
          <div v-else-if="item.name">{{item.name}}</div>
        </div>
        <!-- <img v-if="item.file.type.includes('image')" class="imgItem item" :src="item.path" />
                <div v-else-if="item.file.type.includes('video')" class="videoItem item">
                    <img class="miniVideoIcon videoIcon" src="https://imagessl.edujia.com/A-1ed71af7_20231013134229.png">
                    <img :src="item.videoInfo.poster">
                </div>
                <div v-else class="fileItem item" >
                   <img :src="item.icon" />
                   <div>{{item.file.name}}</div>
               </div> -->
        <div v-if="item.fileType=='img'" class="fileLabel">图片{{item.newImportIdx+1}}</div>
        <div v-else-if="item.fileType=='video'" class="fileLabel">视频{{item.newImportIdx+1}}</div>
        <div v-else-if="item.fileType=='audio'" class="fileLabel">音频{{item.newImportIdx+1}}</div>
        <div v-else class="fileLabel">文件{{item.newImportIdx+1}}</div>
        <div v-if="item.file.type.includes('video')" class="videoPoster" :id="'video'+item.newImportIdx">
          <div class="videoPosterT">
            <img class="videoIcon" src="https://imagessl.edujia.com/A-1ed71af7_20231013134229.png">
            <div class="videoItemVideo"
              :style="`background: url(`+item.videoInfo.poster+`)center center / cover no-repeat;`"></div>
          </div>
          <div class="videoPosterB">
            <div class="videoPosterBL" :id="'videoQr'+item.newImportIdx"></div>
            <div class="videoPosterBR">
              <div class="videoPosterBRT">扫一扫看视频</div>
              <div class="videoPosterBRB">视频时长{{$common.ts2timeDay(item.videoInfo.duration*1000)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isElectron" class="btnBar">
      <div class="cancelBtn" @click="cancelbtnClick">取消</div>
      <div class="saveBtn" :class="{'saveBtnSaving': saving}" @click="savebtnClick">保存</div>
    </div>
    <input v-show="false" type="file" ref="fileInput" @change="fileImport" multiple>
    <face-panel v-if="facePanelShow" @facePanelClose="facePanelShow=false" @emojiClick="emojiClick"></face-panel>
  </div>
</template>

<script>
  import editorFile from '@/components/editorFile'
  import menubar from '@/components/menubar'
  import qiniuService from "@/service/qiniuService"
  import facePanel from '@/components/FacePanel'
  import html2canvas from 'html2canvas';
  import QRCode from 'qrcodejs2'
  import Vue from 'vue'
    import {
        Radio,
        RadioGroup,
        Checkbox
    } from 'element-ui';
    Vue.use(RadioGroup)
    Vue.use(Radio)
    Vue.use(Checkbox)

  // 调试日志：写入 /tmp/wminput-huashu.log（Electron 渲染层有 nodeIntegration，可直接写文件）
  // 用于排查"添加到话术时剪贴板文案没同步"的时序问题
  function hlog(msg) {
    try {
      if (!window.require) return;
      const fs = window.require('fs');
      const vis = document.visibilityState;
      fs.appendFileSync('/tmp/wminput-huashu.log', new Date().toISOString() + ' [edit vis=' + vis + '] ' + msg + '\n');
    } catch (e) {}
  }

  export default {
    props: ['speechIdProps','labelIdProps','checkId'],
    data() {
      return {
        pageWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        pageHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        isFront: localStorage.getItem("isFront") ? parseInt(localStorage.getItem("isFront")) : 1,
        title: "",
        content: "",
        speechId: this.$route.query.speechId||this.speechIdProps,
        labelId: this.$route.query.labelId||this.labelIdProps,
        editHuashuData: null,
        contentHeight: 0,
        huashuId: null,
        fileList: [],
        newImgCount: 0,
        newVideoCount: 0,
        newAudioCount: 0,
        newFileCount: 0,
        currentSendFileListLen: 0,
        loading: false,
        saving: false, //保存请求进行中，防止连点重复提交
        huashuInfoSeq: 0, //每次注入话术数据的序号，用于丢弃上一次遗留的异步任务
        lastTextIndex: 0,
        videoPosterWidth: 276,
        videoPosterHeight: 276,
        canUploadType: [1,2,3,4], //可上传类型，1图片，2视频，3文件，4语音
        huashuLimitPromise: null, //上传限制查询的请求缓存（打开窗口时预取，选文件前 await 同一个请求，避免重复请求）
        audioList: [],
        imgUrlList: [],
        eleList: [],
        isCarryTitle:false,
        facePanelShow:false,
        huashuContent:"",
        isLianhangStart:false,
        huashuValList:[],
        isTop:false,
        isWeb:false,
      }
    },
    computed:{
      isElectron(){
        return window.require&&window.require('electron')
      }
    },
    components: {
      facePanel,
      menubar,
      editorFile
    },
    watch:{
      speechIdProps(newVal) {
        if (newVal) {
          this.speechId = newVal;
        }
      },
      labelIdProps(newVal) {
        if (newVal) {
          this.labelId = newVal;
        }
      },
    },
    methods: {
      replaceHuashuBianliang(text) {
        if (typeof text !== "string") {
          return text;
        }
        this.huashuValList.forEach((val) => {
          //变量没填值时显示字段名占位，避免渲染成 undefined
          let valText = val.value;
          if (valText === undefined || valText === null || valText === "") {
            valText = val.fieldText ? "{" + val.fieldText + "}" : "[变量]";
          }
          let tmp = '<span class="valueTag" data-val="'+val.id+'" style="color:#4A90E2" contenteditable="false">'+valText+"</span>";
          text = this.replaceAll(text, "{$*" + val.id + "*$}", tmp);
        });
        const regex = /\{\$\*\d+\*\$\}/g;
        text = text.replace(regex, "[变量]");
        return text;
      },
      convertValueTags2Text(htmlTxt) {
        let valueTagArr = document.getElementsByClassName("valueTag")
        for(let i=0;i<valueTagArr.length;i++){
          let valueTag = valueTagArr[i]
          let valTagId = valueTag.getAttribute("data-val")
          let tagTxt = "{$*"+valTagId+"*$}"
          htmlTxt=this.replaceAll(htmlTxt, valueTag.outerHTML, tagTxt);
        }
        return htmlTxt;
      },
      convertColorTags(html) {
        // 使用正则全局替换所有匹配的标签
        return html.replace(
          /<标记颜色开始(#(?:[\da-fA-F]{3}){1,2})>([\s\S]*?)<\/标记颜色结束>/gi,
          (match, colorCode, content) => {
            // return `<span class="colorTag" contenteditable="false" style="color: ${colorCode}">${content}</span>`;
            return `<span class="colorTag" style="color: ${colorCode}">${content}</span>`;
          }
        );
      },
      convertColorTags2Text(htmlTxt) {
        let colorTagArr = document.getElementsByClassName("colorTag")
        for(let i=0;i<colorTagArr.length;i++){
          let colorTag = colorTagArr[i]
          let color = colorTag.style.color
          let hexColor= this.$common.rgbToHex(color)
          let content = colorTag.innerText;
          let tagTxt = "<标记颜色开始"+hexColor+">"+content+"</标记颜色结束>"
          htmlTxt=this.replaceAll(htmlTxt, colorTag.outerHTML, tagTxt);
        }
        return htmlTxt;
      },
      //type: img、video、file
      getContentEditorFileItem(path,type,file){
          const fileElement = document.createElement('div');
          fileElement.setAttribute('id', 'edit'+path);
          fileElement.setAttribute('contenteditable', 'false');

          if(type=='img'){
            // fileElement.setAttribute('style', `background-image: url(${path})`);
            // fileElement.setAttribute('class', 'contentImgItem');
            const imgEle = document.createElement('img');
            imgEle.setAttribute('class', 'contentImgItemImg');
            imgEle.setAttribute('src', path);
            fileElement.setAttribute('class', 'contentImgItem');
            fileElement.appendChild(imgEle);
          }else if(type=='video'){
            const videoEle = document.createElement('video');
            videoEle.setAttribute('src', path);
            fileElement.setAttribute('class', 'contentVideoItem');
            fileElement.appendChild(videoEle);
            const videoIconEle = document.createElement('img');
            videoIconEle.setAttribute('src', 'https://imagessl.edujia.com/A-1ed71af7_20231013134229.png');
            videoIconEle.setAttribute('class','contentVideoItemIcon')
            fileElement.appendChild(videoIconEle);
          }else if(type=='videoPreview'){
            // fileElement.setAttribute('style', `background-image: url(${path})`);
            // fileElement.setAttribute('class', 'contentVideoPrviewItem');
            const imgEle = document.createElement('img');
            imgEle.setAttribute('class', 'contentImgItemImg');
            imgEle.setAttribute('src', path);
            fileElement.setAttribute('class', 'contentVideoPrviewItem');
            fileElement.appendChild(imgEle);
          }else if(type=='file'){
            const fileoEle = document.createElement('div');
            fileElement.appendChild(fileoEle)
            const iconEle = document.createElement('img');
            let fileName = file.fileName||file.file.name
            iconEle.src=this.getFileIcon(fileName)
            iconEle.setAttribute('class','contentFileItemIcon')
            fileElement.appendChild(iconEle)
            const nameEle = document.createElement('div');
            nameEle.innerHTML=fileName
            nameEle.setAttribute('class','contentFileItemLabel')
            fileElement.appendChild(nameEle)
            fileElement.setAttribute('class', 'contentFileItem');
          }

          const delBtn = document.createElement('img');
          delBtn.style['background-image']='url(https://imagessl.lingtuo.cn/A-1ed71af7_20250813145017.png)'
          // delBtn.setAttribute('style', "background-image:url(https://imagessl.lingtuo.cn/A-1ed71af7_20250813145017.png)");
          delBtn.setAttribute('class', "contentImgItemDel");
          delBtn.dataset.event = "img-del"; 
          delBtn.dataset.uid = path; 
          if(type=='img'){
            // delBtn.setAttribute('style', "left:90px");
            delBtn.style.left = '90px'
          }
          fileElement.appendChild(delBtn);
          return fileElement;
      },
      getContentEditPartItem(){
        const customEl = document.createElement('span');
        customEl.className = 'custom-element';
        customEl.contentEditable = 'false'; // 防止嵌套编辑
        customEl.textContent = '<分段>';
        // customEl.style.backgroundColor = '#ffeb3b';
        customEl.style.padding = '2px 5px';
        customEl.style.margin = '0 2px';
        return customEl;
      },
      getContentEditLianhangStartItem(){
        const customEl = document.createElement('span');
        customEl.className = 'custom-element';
        customEl.textContent = '<连行开始>';
        customEl.style.backgroundColor = '#ffeb3b';
        customEl.style.padding = '2px 5px';
        customEl.style.margin = '0 2px';
        return customEl;
      },
      contentEditorClick(e){
        console.log("contentEditorClick e:",e);
        console.log("contentEditorClick e.target.dataset.event:",e.target.dataset.event);
        if(e.target.dataset.event == "img-del"){
          let path = e.target.dataset.uid;
          let fileElement = document.getElementById('edit'+path)
          if(fileElement){
            // fileElement.remove();
            fileElement.parentNode.removeChild(fileElement)
            let resultIdx = this.fileList.findIndex((val)=>{
              return val.path == path || val.url == path
            })
            if(resultIdx>=0){
              this.fileList.splice(resultIdx,1)
            }
          }
        }
      },
      emojiClick(emoji){
        // this.content +=emoji.emoji
        // 1. 获取可编辑区域和Selection对象
        const editor = this.$refs.contentEditor;
        const selection = window.getSelection();

        // 2. 检测是否有有效选区
        if (selection.rangeCount === 0){
          editor.focus()
          // return;
        }  

        // 3. 复制当前选区范围
        const range = selection.getRangeAt(0).cloneRange();

        // 4. 创建自定义元素
        const customEl = document.createElement('span');
        customEl.textContent = emoji.emoji;
        // const customEl  =  this.getContentEditPartItem();

        // 5. 插入元素并更新选区位置
        range.insertNode(customEl);
        
        // 6. 将光标设置在新元素后方
        const newRange = document.createRange();
        newRange.setStartAfter(customEl);
        newRange.collapse(true);
        
        selection.removeAllRanges();
        selection.addRange(newRange);
        
        // 7. 聚焦可编辑区域
        editor.focus();
        // this.$refs.contentEditor.innerHTML+=emoji.emoji
      },
      faceBtnClick(){
          this.facePanelShow=!this.facePanelShow;
      },
      insertPartSimbol() {

        // 1. 获取可编辑区域和Selection对象
        const editor = this.$refs.contentEditor;
        const selection = window.getSelection();

        // 2. 检测是否有有效选区
        if (selection.rangeCount === 0){
          editor.focus()
          // return;
        }  

        // 3. 复制当前选区范围
        const range = selection.getRangeAt(0).cloneRange();

        // 4. 创建自定义元素
        // const customEl = document.createElement('span');
        // customEl.className = 'custom-element';
        // customEl.contentEditable = 'false'; // 防止嵌套编辑
        // customEl.textContent = '<分段>';
        // customEl.style.backgroundColor = '#ffeb3b';
        // customEl.style.padding = '2px 5px';
        // customEl.style.margin = '0 2px';
        const customEl  =  this.getContentEditPartItem();

        // 5. 插入元素并更新选区位置
        range.insertNode(customEl);
        
        // 6. 将光标设置在新元素后方
        const newRange = document.createRange();
        newRange.setStartAfter(customEl);
        newRange.collapse(true);
        
        selection.removeAllRanges();
        selection.addRange(newRange);
        
        // 7. 聚焦可编辑区域
        // editor.focus();

        // let tmp = this.content.split('');
        // if (tmp[this.lastTextIndex - 1] && tmp[this.lastTextIndex - 1] == '\n' && tmp[this.lastTextIndex + 5] && tmp[
        //     this.lastTextIndex + 5] == '\n') {
        //   tmp.splice(this.lastTextIndex, 0, "<分段>")
        // } else if (tmp[this.lastTextIndex - 1] && tmp[this.lastTextIndex - 1] == '\n' && tmp[this.lastTextIndex] !== '\n') {
        //   tmp.splice(this.lastTextIndex, 0, "<分段>\n")
        // }else if (tmp[this.lastTextIndex - 1] && tmp[this.lastTextIndex - 1] == '\n'&& tmp[this.lastTextIndex] == '\n') {
        //   tmp.splice(this.lastTextIndex, 0, "<分段>")
        // }else if (tmp[this.lastTextIndex + 5] && tmp[this.lastTextIndex + 5] == '\n') {
        //   tmp.splice(this.lastTextIndex, 0, "\n<分段>")
        // } else if(tmp[this.lastTextIndex]=='\n'){
        //   tmp.splice(this.lastTextIndex, 0, "\n<分段>")
        // } else {
        //   tmp.splice(this.lastTextIndex, 0, "\n<分段>\n")
        // }
        // this.content = tmp.join('');
      },
      onBlur() {
        this.lastTextIndex = this.getSelection();
        console.log("onBlur...lastTextIndex:",this.lastTextIndex);
      },
      insertCursorPosition(ele) {
        // 1. 获取可编辑区域和Selection对象
        const editor = this.$refs.contentEditor;
        const orgContent = editor.innerHTML;
        const selection = window.getSelection();

        // 2. 检测是否有有效选区
        if (selection.rangeCount === 0) return;

        // 3. 复制当前选区范围
        const range = selection.getRangeAt(0).cloneRange();
        // 5. 插入元素并更新选区位置
        range.insertNode(ele);
        
        // 6. 将光标设置在新元素后方
        const newRange = document.createRange();
        newRange.setStartAfter(ele);
        newRange.collapse(true);
        
        selection.removeAllRanges();
        selection.addRange(newRange);
        
        // 7. 聚焦可编辑区域
        editor.focus();
      },
      // 判断光标是否在文本末尾的方法
      isCursorAtEnd(editableElement) {
          const selection = window.getSelection();
          
          if (selection.rangeCount === 0) {
              return false;
          }
          
          const range = selection.getRangeAt(0);
          // 如果选区未折叠（有选中文本），则光标不在末尾
          if (!range.collapsed) {
              return false;
          }
          
          // 创建从光标位置到编辑区域末尾的范围
          const endRange = document.createRange();
          endRange.setStart(range.endContainer, range.endOffset);
          endRange.setEnd(editableElement, editableElement.childNodes.length);
          
          // 获取光标位置到末尾的文本内容
          const textAfterCursor = endRange.toString();
          
          // 如果光标后有文本，则光标不在末尾
          return textAfterCursor === '' || textAfterCursor === '\n';
      },
      getSelection() {
        let textarea = this.$refs['textarea'];

        // 获取文本域光标光标的开始位置和结束位置

        // 1. 位置定义：文本框中有文字的话，第一个文字的左边是0，右边是1，第二个文字的左边是1，右边是2
        // 2. 当页面刚加载完，文本域中有默认文字，那么selectionStart和selectionEnd都是相同的数值，都是最后一个位置，即有多少个文字，数值就是多少
        // 3. 如果是选中了文本，那么selectionStart就是被选中文字最左边开始的位置的数值（上面已说明），selectionEnd就是被选中文字最右边结束的位置的数值（上面已说明）
        // 4. 注意：当点击了文本域某个位置（或选择了一段文字），然后又失去焦点，仍然可以通过下面的方法获取到光标之前的位置
        // console.log(textarea.selectionStart,textarea.selectionEnd,'start,end');
        return textarea?textarea.selectionStart:0;
      },
      setSelection() {

        let textarea = this.$refs['textarea'];

        // 调用setSelectionRange方法去选中文本前，一定要先focus
        textarea.focus();
        // 将光标选中指定的文字，如果指定的selectionStart和selectionEnd相同，那就是选择固定的某个位置。如果不同，那就是选择一段文字。
        textarea.setSelectionRange(1, 2)
      },
      delClick(idx) {
        let file = this.fileList[idx];
        if (file) {
          let textLabel = ""
          if (file.fileType.includes("img")) {
            textLabel = "<图片" + (file.newImportIdx + 1) + ">"
          } else if (file.fileType.includes("video")) {
            textLabel = "<视频" + (file.newImportIdx + 1) + ">"
          } else if (file.fileType.includes("audio")) {
            textLabel = "<音频" + (file.newImportIdx + 1) + ">"
          } else {
            textLabel = "<文件" + (file.newImportIdx + 1) + ">"
          }
          let tmp = this.content.split(textLabel);
          this.content = tmp.join("")
        }
        this.fileList.splice(idx, 1)
      },
      changeFront(val) {
        this.isFront = val;
        localStorage.setItem("isFront", val)
      },
      backClick() {
        this.$router.go(-1);
      },
      replaceContentItem2Url(){
        let htmlStr = this.$refs.contentEditor.innerHTML;
       
        this.fileList.forEach((file) => {
          let fileStr  = file.domItemStr;
          let tmp = htmlStr.split(fileStr)
          if(tmp&&tmp.length>=2){
            // let tmpPre = tmp[0].slice(-1)=='\n'?tmp[0]:tmp[0]+'\n'
            let tmpPre = tmp[0];
            if(tmp[1].substr(0,2)=='\n\n'){
              console.log("tmp1 == ",tmp[1])
            }
            let tmpLast = tmp[1].substr(0,1)=='\n'?tmp[1]:'\n'+tmp[1]
            htmlStr = file.fileType.includes("video") ?tmpPre+ file.qrPosterUrl+tmpLast : tmpPre+file.url+tmpLast;  
          }
        })
        //   let htmlStr2 =this.replaceAll(htmlStr, "<div>", "");
        // let htmlStr3 =this.replaceAll(htmlStr2, "</div>", "");
        // let htmlStr4 = this.replaceBrTags(htmlStr3,"\n");
        // this.$refs.contentEditor.innerHTML =htmlStr4;
        this.$refs.contentEditor.innerHTML =htmlStr;
        // setTimeout(() => {
          console.log("this.$refs.contentEditor.innerText:",this.$refs.contentEditor.innerText);
        // }, 1);
      },
      replaceTag2Url() {
        this.fileList.forEach((file) => {
          let textLabel = ""
          if (file.fileType.includes("img")) {
            textLabel = "<图片" + (file.newImportIdx + 1) + ">"
          } else if (file.fileType.includes("video")) {
            textLabel = "<视频" + (file.newImportIdx + 1) + ">"
          } else if (file.fileType.includes("audio")) {
            textLabel = "<音频" + (file.newImportIdx + 1) + ">"
          } else {
            textLabel = "<文件" + (file.newImportIdx + 1) + ">"
          }
          let tmp = this.content.split(textLabel);
          // this.content=tmp.join("")
          this.content = file.fileType.includes("video") ? tmp[0] + file.qrPosterUrl + tmp[1] : tmp[0] + file.url +
            tmp[1];
        })
      },
      cancelbtnClick(){
        if (localStorage.getItem("editHuashuData")) {
            localStorage.removeItem("editHuashuData")
        }
        if(window.require&& window.require('electron')){
            const { ipcRenderer } = window.require('electron');
            let _this=this;
            ipcRenderer.send('closeHuashuEdit')
        }else{
          this.$emit("huashuEditClose")
        }
      },
      getEditorText(node) {
          let result = "";
          const childNodes = node.childNodes;

          for (let i = 0; i < childNodes.length; i++) {
              const child = childNodes[i];

              // 1. 处理文本节点
              if (child.nodeType === Node.TEXT_NODE) {
                  result += child.nodeValue;
              } 
              // 2. 处理元素节点
              else if (child.nodeType === Node.ELEMENT_NODE) {
                  const tagName = child.tagName.toLowerCase();

                  // 如果是自定义组件 (通过 class 或 tag 判断)
                  if (child.classList.contains('custom-component')) {
                      // 这里可以根据需求：是取它的文本，还是取它的 data-value
                      result += child.innerText; 
                  } 
                  // 如果是显式的换行符
                  else if (tagName === 'br') {
                      result += "\n";
                  } 
                  // 如果是块级包装容器 (div, p)
                  else if (window.getComputedStyle(child).display === 'block') {
                      const subText = this.getEditorText(child);
                      if (subText) {
                          // 如果已经有内容了，且上一个字符不是换行，则这个块代表一个新行
                          if (result !== "" && !result.endsWith('\n')) {
                              result += "\n";
                          }
                          result += subText;
                          // 块结束通常代表一个换行
                          if (!result.endsWith('\n')) {
                              result += "\n";
                          }
                      } else if (tagName === 'div') {
                          // 处理 <div><br></div> 这种情况，视作一个换行
                          result += "\n";
                      }
                  } 
                  // 如果是 span 等行内元素，递归进去即可
                  else {
                      result += this.getEditorText(child);
                  }
              }
          }
          return result;
      },
      // 辅助：获取并清理重复换行（针对不同浏览器内核微调）
      getCleanedText(editorEl) {
          let text = this.getEditorText(editorEl);
          
          // 修正：浏览器在 contenteditable 中即便你只按一次回车，
          // 有时也会产生两个块结尾。我们把超过粘贴预期的翻倍换行还原。
          // 如果你发现 1\n\n\n2 变成了 1\n\n\n\n\n2
          // 说明是 \n 与 块换行重叠了。
          
          // 这里的逻辑是：如果设置了 white-space: pre-wrap
          // 文本节点内部的 \n 已经是生效的，不需要外层 div 再贡献换行。
          return text.trimEnd(); // 去掉末尾最后一个回车
      },
      // 处理主进程注入的话术数据：编辑已有话术 / 新增（可带剪贴板文案）
      handleHuashuInfo(huashuInfo) {
          //实例已销毁的旧监听直接退出，避免访问 $refs 抛错
          if (this._isDestroyed || this._isBeingDestroyed) return;
          hlog('handleHuashuInfo keys=' + (huashuInfo ? Object.keys(huashuInfo).join(',') : 'null')
              + ' prefillLen=' + ((huashuInfo && huashuInfo.prefillText) ? String(huashuInfo.prefillText).length : 0)
              + ' prefillMedia=' + ((huashuInfo && huashuInfo.prefillMedia) ? huashuInfo.prefillMedia.type : 'none')
              + ' editId=' + ((huashuInfo && huashuInfo.editHuashuData) ? huashuInfo.editHuashuData.id : 'none')
              + ' editorRef=' + !!this.$refs.contentEditor);
          if (!huashuInfo) {
              this.clearHuashuEditForm();
              return;
          }
          console.log("getSettingInfoResp huashuInfo:", huashuInfo);
          //窗口每次打开先清掉上一次残留的提示（比如上次保存失败的“话术已存在”）
          this.$message.closeAll();
          this.saving = false;
          //每次注入都自增序号：窗口没被销毁、只是又收到一次数据时，
          //上一次注入遗留的异步任务（编辑初始化/预填重试）靠这个序号判断自己已过期，避免覆盖新内容
          const seq = ++this.huashuInfoSeq;
          this.speechId = huashuInfo.speechId;
          this.labelId = huashuInfo.labelId;
          //换了团队/话术，上传限制重新查一次（清掉上一次的请求缓存）
          this.huashuLimitPromise = null;
          if (huashuInfo.editHuashuData) {
              this.editHuashuData = huashuInfo.editHuashuData;
              this.huashuId = huashuInfo.editHuashuData.id;
              //用 $nextTick（微任务）而不是 setTimeout：窗口长时间隐藏时 Chromium 会节流宏任务计时器，
              //setTimeout 可能几十秒后才执行，导致打开窗口后内容迟迟不出现
              this.$nextTick(() => {
                  if (seq !== this.huashuInfoSeq) return;
                  this.initEditHuashuData();
              });
          } else {
              this.clearHuashuEditForm();
              if (huashuInfo.prefillText) {
                  //剪贴板“添加到话术”带过来的文案，直接填入内容编辑器
                  //注意：这里不能放 setTimeout —— 窗口长时间隐藏后计时器会被 Chromium 节流，
                  //预填会迟迟不执行（表现为"文案没同步"）。直接同步写，ref 未就绪时方法内部会重试。
                  this.applyPrefillText(huashuInfo.prefillText, seq);
              } else if (huashuInfo.prefillMedia) {
                  //剪贴板“添加到话术”带过来的图片/文件（只有落盘路径，见 applyPrefillMedia）
                  this.applyPrefillMedia(huashuInfo.prefillMedia, seq);
              }
          }
          hlog('handleHuashuInfo done seq=' + seq + ' editorHTML.len=' + (this.$refs.contentEditor ? this.$refs.contentEditor.innerHTML.length : -1));
          //打开/预填话术窗口时预取上传限制：silent + 异常兜底，接口报错也不会再弹“系统异常”
          this.qryHuashuLimit();
      },
      // 清空“新增话术”的表单
      clearHuashuEditForm() {
          this.editHuashuData = null;
          this.title = "";
          this.content = "";
          this.isCarryTitle = "";
          this.fileList = [];
          this.huashuId = null;
          this.newImgCount = 0;
          this.newVideoCount = 0;
          this.newAudioCount = 0;
          this.newFileCount = 0;
          if (this.$refs.contentEditor) {
              this.$refs.contentEditor.innerHTML = "";
          }
          hlog('clearHuashuEditForm editorRef=' + !!this.$refs.contentEditor);
      },
      // 把外部带过来的文案填入内容编辑器（换行统一转成<br>，与 getEditorText 的换行读取逻辑一致）
      applyPrefillText(text, seq) {
          //序号对不上说明已经有更新的注入，当前这次不能再写
          const isStale = () => (seq !== undefined && seq !== this.huashuInfoSeq);
          const setContent = () => {
              if (isStale()) {
                  hlog('applyPrefillText 放弃：已被更新的注入取代 seq=' + seq + ' now=' + this.huashuInfoSeq);
                  return true;
              }
              if (!this.$refs.contentEditor) {
                  return false;
              }
              const raw = text == null ? "" : String(text);
              const escaped = raw
                  .replace(/&/g, "&amp;")
                  .replace(/</g, "&lt;")
                  .replace(/>/g, "&gt;");
              this.$refs.contentEditor.innerHTML = escaped.replace(/\n/g, "<br>");
              this.content = raw;
              hlog('applyPrefillText 已写入 len=' + raw.length + ' editorHTML.len=' + this.$refs.contentEditor.innerHTML.length);
              return true;
          };
          if (setContent()) {
              return;
          }
          //窗口还没挂载完时（ref 未就绪）稍作重试
          let retry = 0;
          const timer = setInterval(() => {
              retry++;
              if (setContent() || retry > 50) {
                  clearInterval(timer);
              }
          }, 20);
      },
      // 剪贴板带过来的图片/文件：塞进话术的待上传列表。
      //
      // 剪贴板媒体在主进程手上（另一个 BrowserWindow），File 对象不能跨进程传，
      // 所以这边只拿到落盘路径：读盘重建 File 后交给 fileImport，复用「手动选文件」
      // 那条完整链路（上传类型限制校验、后缀白名单、编辑器内联节点、保存时走七牛
      // 上传并回填 url）。之所以坚持复用而不是自己拼 fileList：
      // fileImport 里 domItemStr / url / fileList 三者是联动的，保存时
      // replaceContentItem2Url 靠 domItemStr 在 innerHTML 里定位并替换成 url，
      // 自己重写一遍极容易漏掉这个关系，导致图片/文件进不了话术内容。
      applyPrefillMedia(media, seq) {
          //序号对不上说明已经有更新的注入，当前这次不能再写
          const isStale = () => (seq !== undefined && seq !== this.huashuInfoSeq);
          const run = () => {
              if (isStale()) {
                  hlog('applyPrefillMedia 放弃：已被更新的注入取代 seq=' + seq + ' now=' + this.huashuInfoSeq);
                  return true;
              }
              if (!this.$refs.fileInput || !this.$refs.contentEditor) {
                  return false;
              }
              this.prefillMediaFiles(media);
              return true;
          };
          if (run()) return;
          //窗口还没挂载完时（ref 未就绪）稍作重试
          let retry = 0;
          const timer = setInterval(() => {
              retry++;
              if (run() || retry > 50) {
                  clearInterval(timer);
              }
          }, 20);
      },
      // 后缀 -> MIME。fileImport 的上传类型判断走的是 file.type（image/video/audio），
      // 所以这里必须给出准确类型，否则会被当成"文件"或被错误地拦掉。
      // 未列出的后缀给 octet-stream，交给 fileImport 里的后缀白名单去提示"不支持上传"。
      prefillMediaMimeType(name) {
          const ext = String(name || '').split('.').pop().toLowerCase();
          const map = {
              png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg',
              gif: 'image/gif', bmp: 'image/bmp', webp: 'image/webp',
              tif: 'image/tiff', tiff: 'image/tiff',
              pdf: 'application/pdf',
              doc: 'application/msword',
              docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
              dotm: 'application/vnd.ms-word.template.macroEnabled.12',
              txt: 'text/plain',
              xls: 'application/vnd.ms-excel',
              xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              mp4: 'video/mp4', mov: 'video/quicktime',
              mp3: 'audio/mpeg', m4a: 'audio/mp4', aac: 'audio/aac', caf: 'audio/x-caf',
              ppt: 'application/vnd.ms-powerpoint',
              pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
          };
          return map[ext] || 'application/octet-stream';
      },
      // 剪贴板图片是主进程按内容哈希落盘的，文件名是一长串 sha1；
      // 这里给个人看得懂的名字，同时也是 fileImport 判后缀的依据（必须是 .png）
      clipboardImageDisplayName() {
          const d = new Date();
          const pad = (n) => (n < 10 ? '0' + n : '' + n);
          return '剪贴板图片_' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) +
              '_' + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds()) + '.png';
      },
      // 把落盘路径读成 File，再交给 fileImport
      prefillMediaFiles(media) {
          const fs = window.require && window.require('fs');
          if (!fs || !media) return;
          const items = [];
          if (media.type === 'image') {
              if (media.imagePath) {
                  items.push({
                      path: media.imagePath,
                      name: this.clipboardImageDisplayName()
                  });
              }
          } else {
              (media.files || []).forEach((f) => {
                  if (!f || !f.path) return;
                  const base = f.name || String(f.path).split(/[\\/]/).pop();
                  items.push({
                      path: f.path,
                      name: base || 'clipboard-file'
                  });
              });
          }
          if (!items.length) {
              this.$message({
                  message: '内容已失效，无法添加到话术',
                  type: 'warning'
              });
              return;
          }

          const files = [];
          let skipped = 0;
          items.forEach((it) => {
              try {
                  // 文件夹不能当文件上传（readFileSync 会 EISDIR）
                  if (fs.statSync(it.path).isDirectory()) {
                      skipped++;
                      return;
                  }
                  const buf = fs.readFileSync(it.path);
                  files.push(new File([buf], it.name, {
                      type: this.prefillMediaMimeType(it.name),
                      lastModified: Date.now()
                  }));
              } catch (e) {
                  // 源文件被删/移动/无权限：跳过这一个，其余照常
                  skipped++;
                  hlog('prefillMediaFiles 读取失败 path=' + it.path + ' err=' + ((e && e.message) || e));
              }
          });

          if (skipped) {
              this.$message.closeAll();
              this.$message({
                  message: skipped + ' 个文件不可用（文件夹或已失效），已跳过',
                  type: 'warning'
              });
          }
          if (!files.length) return;

          try {
              // 借 DataTransfer 把 File 放回 input，再走原来的 fileImport：
              // 这样类型限制、后缀白名单、视频封面等逻辑跟"手动选文件"完全一致
              const dt = new DataTransfer();
              files.forEach((f) => dt.items.add(f));
              this.$refs.fileInput.files = dt.files;
              this.putCaretAtEditorEnd();
              const task = this.fileImport({
                  target: this.$refs.fileInput
              });
              // fileImport 一进来就 focus + insertLineBreak，空编辑器里会留下一个开头的空行；
              // 剪贴板带过来的媒体本该是内容的第一项，等它插完再把开头空行去掉
              if (task && task.then) {
                  task.then(() => this.trimEditorLeadingBreaks(), () => {});
              }
          } catch (e) {
              hlog('prefillMediaFiles 注入失败：' + ((e && e.message) || e));
              this.$message({
                  message: '添加到话术失败：' + ((e && e.message) || e),
                  type: 'warning'
              });
          }
      },
      // 把光标放到内容编辑器末尾：剪贴板带过来的媒体应该追加在已有内容之后，
      // 而不是插到某个残留的光标位置上
      putCaretAtEditorEnd() {
          try {
              const editor = this.$refs.contentEditor;
              editor.focus();
              const range = document.createRange();
              range.selectNodeContents(editor);
              range.collapse(false); // 折叠到末尾
              const sel = window.getSelection();
              sel.removeAllRanges();
              sel.addRange(range);
          } catch (_) {}
      },
      // 去掉内容编辑器开头多余的空行（fileImport 进来时会先插一个换行）
      trimEditorLeadingBreaks() {
          try {
              const editor = this.$refs.contentEditor;
              if (!editor) return;
              let guard = 0;
              while (guard++ < 20) {
                  const first = editor.firstChild;
                  if (!first) return;
                  if (first.nodeType === Node.ELEMENT_NODE && first.tagName.toLowerCase() === 'br') {
                      editor.removeChild(first);
                      continue;
                  }
                  // 纯空白文本节点也一并去掉
                  if (first.nodeType === Node.TEXT_NODE && !first.nodeValue.replace(/[\s\u00a0]/g, '')) {
                      editor.removeChild(first);
                      continue;
                  }
                  return;
              }
          } catch (_) {}
      },
      savebtnClick() {
        //防止重复提交：同一条话术并发保存两次，服务端会判为“话术已存在”
        //（网络慢的时候连点保存就会触发，第二次的报错提示还会残留到下次打开窗口）
        if (this.saving) return;
        this.saving = true;
        const done = () => {
          this.saving = false;
        };
        this.doSaveHuashu().then(done, (err) => {
          console.error("huashuSave error:", err);
          done();
        });
      },
      async doSaveHuashu() {
        // for(let i=0;i<this.fileList.length;i++){
        //     let file=this.fileList[i]
        //     if(file.fileType=="video"){
        //         file.posterFile=await this.generateVideoQr("video"+file.newImportIdx);
        //     }
        // }

        if(!this.labelId){
            this.$message({
              message: '请先创建分类',
              type: 'warning'
            });
          return;
        }
        if (this.fileList.length) {
          let newFileList = [];
          const totalFiles = this.fileList;
          let uploadedCount = 0;
          let maxUploadNum = 9;
          let readyFileList = [];
          let forCount = totalFiles.length<maxUploadNum?1:parseInt(totalFiles.length/maxUploadNum)+1;
          for(let i = 0;i<forCount;i++){
            if(uploadedCount + maxUploadNum < totalFiles.length){
              readyFileList=totalFiles.slice(uploadedCount, uploadedCount + maxUploadNum)
              uploadedCount += maxUploadNum;
            }else{
              readyFileList=totalFiles.slice(uploadedCount, totalFiles.length)
              uploadedCount = totalFiles.length;
            }
            console.log("savebtnClick uploadedCount:",uploadedCount);
            if(newFileList.length < this.fileList.length){
              let uploadedFilePart = await this.uploadFileList(readyFileList);
              newFileList.push(...uploadedFilePart)
            }

            if(newFileList.length == this.fileList.length){
              this.fileList = newFileList;
              await this.submitHuashuMapping();
            }
          }
        }else if(!this.fileList.length&&this.isWeb){
          this.content = this.$refs.contentEditor.innerHTML;
        }

        console.log("savebtnClick this.fileList:",this.fileList);

        if(this.isWeb){
          this.replaceContentItem2Url()
          // let tmpTxt = this.$refs.contentEditor.innerHTML;
          
          // tmpTxt = this.replaceAll(tmpTxt, "<*/标记颜色结束>", "</标记颜色结束>");

          this.$refs.contentEditor.innerHTML = this.replaceAll(this.$refs.contentEditor.innerHTML, this.getContentEditPartItem().outerHTML, "<分段>");
          this.$refs.contentEditor.innerHTML = this.convertColorTags2Text(this.$refs.contentEditor.innerHTML);
          this.$refs.contentEditor.innerHTML = this.convertValueTags2Text(this.$refs.contentEditor.innerHTML);

          // let content5 = this.getCleanedText(this.$refs.contentEditor);
          // console.log("content5:",content5)
          
          let tmpTxt = this.getCleanedText(this.$refs.contentEditor);
          // tmpTxt = this.replaceAll(tmpTxt, "<span>", "");
          // tmpTxt = this.replaceAll(tmpTxt, "</span>", "");
          // if(tmpTxt.slice(-1)=='\n'){
          //   tmpTxt=tmpTxt.slice(0,-1);
          // }
          this.content=tmpTxt;
          // this.content = this.$refs.contentEditor.innerHTML;
        }else{
          this.replaceTag2Url()
        }

        // if(!this.title.length){
        //     this.$message({
        //       message: '标题不能为空',
        //       type: 'warning'
        //     });
        //     return;
        // }
        if (!this.content.length) {
          this.$message({
            message: '内容不能为空',
            type: 'warning'
          });
          return;
        }

        let sortType=this.isFront;
        if(this.isTop&&sortType==1){
          sortType = 4
        }
        if(this.isTop&&sortType==2){
          sortType = 5
        }

        let params = {
          speechId: this.speechId,
          labelId: this.labelId,
          speechText: this.content,
          editTime: new Date().getTime(),
          isCarryTitle: this.isCarryTitle?1:0,
          sortType: sortType,
        }
        if(this.checkId){
          params.checkId = this.checkId;
        }
        if (this.title.length) {
          params.title = this.title;
        }
        if (this.huashuId) {
          params.id = this.huashuId;
        }
        console.log("huashuSave params=", params);
        let resp = await this.$http.huashuSave(params)
        console.log("huashuSave resp:", resp)
        if (resp.code === 200) {
          let result = resp.data.object;
          result.isFront = this.isFront;
          // localStorage.setItem("updateHuashuItem", JSON.stringify(result))
          // this.$router.go(-1);
          if(window.require&& window.require('electron')){
              const { ipcRenderer } = window.require('electron');
              let _this=this;
              ipcRenderer.send('updateHuashuItem',JSON.stringify(result));
              ipcRenderer.send('closeHuashuEdit')
          }else if(this.isWeb){
            this.$emit("huashuEditSuccess")
          }
        } else {
          //话术待审核
          if(resp.code == 802106){
            this.$emit("huashuEditSuccess")
          }

          this.$message({
            message: resp.message,
            type: 'warning'
          });
        }
      },
      addMediaBtnClick() {
        this.$refs.fileInput.click();
        // this.$alert('请使用微脉输入法App添加图片、视频和文件', '提示', {
        //   // confirmButtonText: '确定',
        //   showConfirmButton:false,
        //   callback: action => {

        //   }
        // });
      },
      getBaseURL(file) {
        var url = null;
        if (window.createObjectURL != undefined) { // basic
          url = window.createObjectURL(file)
        } else if (window.URL != undefined) { // mozilla(firefox)
          url = window.URL.createObjectURL(file)
        } else if (window.webkitURL != undefined) { // webkit or chrome
          url = window.webkitURL.createObjectURL(file)
        }
        return url;
      },
      generateVideoQr(domId) {
        return new Promise((resolve, reject) => {
          html2canvas(document.getElementById(domId), {
            useCORS: true,
          }).then((canvas) => {
            // document.body.appendChild(canvas);
            let dataUrl = this.convertCanvasToImage(canvas);
            let blob = this.dataURLtoBlob(dataUrl);
            let file = this.blobToFile(blob, domId);
            resolve(file)
          });
        })
      },
      getAudioInfo(file) {
        return new Promise((resolve, reject) => {
          let url = URL.createObjectURL(file); //获取录音时长
          const audioElement = document.createElement('audio')
          audioElement.setAttribute("preload", 'auto')
          audioElement.src = url
          audioElement.addEventListener("loadeddata", (_event) => {
            resolve({
              duration: audioElement.duration,
            })
          });
        })
      },
      getVideoInfo(file) {
        return new Promise((resolve, reject) => {
          let url = URL.createObjectURL(file); //获取录音时长
          const videoElement = document.createElement('video')
          videoElement.setAttribute("preload", 'auto')
          videoElement.src = url
          let duration;
          videoElement.addEventListener("loadeddata", (_event) => {
            const canvas = document.createElement('canvas')
            // canvas.width = this.videoPosterWidth * 0.2              
            // canvas.height = this.videoPosterHeight *0.2
            canvas.width = this.videoPosterWidth
            canvas.height = videoElement.videoHeight / videoElement.videoWidth * this.videoPosterHeight
            const ctx = canvas.getContext('2d')
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height)
            // const image = new Image()
            // canvas.toDataURL('image/png')即图片的base64              
            // image.src = canvas.toDataURL('image/png')
            //  // blob形式
            //  canvas.toBlob((blob) => {
            //      console.log(blob)             
            // }, 'image/png')
            resolve({
              duration: videoElement.duration,
              poster: canvas.toDataURL('image/png')
            })
          });
        })
      },
      /**
       * 二进制容器
       * @param {String} dataurl
       */
      getUint8Arr(dataurl) {
        // 截取base64的数据内容
        let arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          // 获取解码后的二进制数据的长度，用于后面创建二进制数据容器
          n = bstr.length,
          // 创建一个Uint8Array类型的数组以存放二进制数据
          u8arr = new Uint8Array(n)
        // 将二进制数据存入Uint8Array类型的数组中
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return {
          u8arr,
          mime
        }
      },
      /**
       * canvas转dataURL
       * @param {canvas} canvas
       */
      convertCanvasToImage(canvas) {
        // let image = new Image()
        // image.src = canvas.toDataURL('image/png')
        return canvas.toDataURL('image/png')
      },
      /**
       * dataURL转Blob对象
       * @param {String} dataurl
       */
      dataURLtoBlob(dataurl) {
        let uint8 = this.getUint8Arr(dataurl)
        return new Blob([uint8.u8arr], {
          type: uint8.mime
        })
      },
      /**
       * Blob转换为File
       * @param {Blob} theBlob
       * @param {String} fileName
       */
      blobToFile(theBlob, fileName) {
        theBlob.lastModifiedDate = new Date()
        theBlob.name = fileName
        return theBlob
      },
      calculateStringLength(n) {
          if (n <= 0) return 0;
          if (n === 1) return 1; // 只有数字0，长度为1
          
          let totalLength = 1; // 数字0的长度为1
          const m = n - 1; // 计算从1到m的数字
          
          // 计算m的位数
          const digits = Math.floor(Math.log10(m)) + 1;
          
          // 计算所有完整位数组的长度
          for (let i = 1; i < digits; i++) {
              totalLength += i * 9 * Math.pow(10, i - 1);
          }
          
          // 计算最高位数组的长度
          totalLength += digits * (m - Math.pow(10, digits - 1) + 1);
          
          return totalLength;
      },
      async fileImport(e) {
        this.$refs.contentEditor.focus()
        let cursorEndFlag = this.isCursorAtEnd(this.$refs.contentEditor);
        console.log("cursorEndFlag:",cursorEndFlag);
        document.execCommand('insertLineBreak');
        // if(this.currentSendFileListLen){
        //   this.$alert('请等待文件传输完成', '提示', {
        //     showConfirmButton:false,
        //     callback: action => {}
        //   });
        //   return
        // }
        let _this = this;
        //选文件前确认上传限制（等打开窗口时预取的那个请求，失败时静默并保持默认全类型）
        await this.qryHuashuLimit();
        let fileList = [];
        for (let idx = 0; idx < e.target.files.length; idx++) {
          let val = e.target.files[idx];
          //是否允许上传图片
          if (val.type.includes("image") && !this.canUploadType.find((val) => {
              return val == 1
            })) {
            this.$message.closeAll();
            this.$message({
              message: '图片上传已被限制',
              type: 'warning'
            });
            continue;
            return;
          }
          //是否允许上传视频
          if (val.type.includes("video") && !this.canUploadType.find((val) => {
              return val == 2
            })) {
            this.$message.closeAll();
            this.$message({
              message: '视频上传已被限制',
              type: 'warning'
            });
            continue;
            return;
          }
          //是否允许上传文件
          if ((!val.type.includes("image") && !val.type.includes("video")) && !this.canUploadType.find((val) => {
              return val == 3
            })) {
            this.$message.closeAll();
            this.$message({
              message: '文件上传已被限制',
              type: 'warning'
            });
            continue;
            return;
          }
          //是否允许上传音频
          if ((!val.type.includes("image") && !val.type.includes("audio")) && !this.canUploadType.find((val) => {
              return val == 4
            })) {
            this.$message.closeAll();
            this.$message({
              message: '音频上传已被限制',
              type: 'warning'
            });
            continue;
            return;
          }

          let fileExtension = val.name.split('.').pop().toLowerCase();
          if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension ===
            'pdf' || fileExtension === 'doc' || fileExtension === 'docx' || fileExtension === 'dotm' ||
            fileExtension === 'dotx' || fileExtension === 'dotm' || fileExtension === 'txt' || fileExtension ===
            'xlsx' || fileExtension === 'xls' || fileExtension === 'mp4' || fileExtension === 'mov' ||
            fileExtension === 'mp3' || fileExtension === 'm4a' || fileExtension === 'aac' || fileExtension ===
            'caf' || fileExtension === 'ppt' || fileExtension === 'pptx') {
            let fileType;
            let newImportIdx;
            let videoInfo;
            let audioInfo;
            if (val.type.includes("image")) {
              fileType = "img";
              newImportIdx = this.newImgCount++;
            } else if (val.type.includes("video")) {
              fileType = "video";
              newImportIdx = this.newVideoCount++;
              videoInfo = await this.getVideoInfo(val);
            } else if (val.type.includes("audio")) {
              fileType = "audio";
              newImportIdx = this.newAudioCount++;
              audioInfo = await this.getAudioInfo(val);
            } else {
              fileType = "file";
              newImportIdx = this.newFileCount++;
            }
            let info = {
              file: val,
              path: this.getBaseURL(val),
              seq: idx,
              fileType: fileType,
              waitUpload: true,
              icon: this.getFileIcon(val.name),
              newImportIdx: newImportIdx,
              id: new Date().getTime() + idx
            }
            if (videoInfo) {
              info.videoInfo = videoInfo
            }
            if (audioInfo) {
              info.audioInfo = audioInfo
            }
            fileList.push(info)
          } else {
            this.$message({
              message: "不支持上传" + fileExtension + "类型文件",
              type: 'warning'
            });
          }
        }
        if (this.content.substring(this.lastTextIndex - 1, 2) != '\n') {
          let tmp = this.content.split("");
          tmp.splice(this.lastTextIndex, 0, "\n")
          this.content = tmp.join("");
          this.lastTextIndex += 1;
        }
        
        fileList.forEach((val, idx) => {
          if(this.isWeb){
            this.$refs.contentEditor.focus();
          }else{
            this.$refs.textarea.focus();
          }
          
          let tmp = this.content.split("");
          if (val.fileType.includes("img")) {
            if(this.isWeb){
              let domItem = this.getContentEditorFileItem(val.path,'img');
              val.domItemStr = domItem.outerHTML;
              this.insertCursorPosition(domItem)
            }else{
              // tmp.splice(this.lastTextIndex + idx * 6, 0, "<图片" + (val.newImportIdx + 1) + ">\n ")
              tmp.splice(this.lastTextIndex + idx * 5+this.calculateStringLength(idx), 0, "<图片" + (val.newImportIdx + 1) + ">\n")
            }
          } else if (val.fileType.includes("video")) {
            if(this.isWeb){
              let domItem = this.getContentEditorFileItem(val.path,'video');
              val.domItemStr = domItem.outerHTML;
              this.insertCursorPosition(domItem)
              // this.insertCursorPosition(this.getContentEditorFileItem(val.path,'video'))
            }else{
              tmp.splice(this.lastTextIndex + idx * 6, 0, "<视频" + (val.newImportIdx + 1) + ">\n")
            }
          } else if (val.fileType.includes("audio")) {
            if(this.isWeb){
              let domItem = this.getContentEditorFileItem(val.path,'file',val);
              val.domItemStr = domItem.outerHTML;
              this.insertCursorPosition(domItem)
              // this.insertCursorPosition(this.getContentEditorFileItem(val.path,'file',val))
            }else{
              tmp.splice(this.lastTextIndex + idx * 6, 0, "<音频" + (val.newImportIdx + 1) + ">\n")
            }
            // tmp.splice(this.lastTextIndex + idx * 6, 0, "<音频" + (val.newImportIdx + 1) + ">\n")
          } else {
            if(this.isWeb){
              let domItem = this.getContentEditorFileItem(val.path,'file',val);
              val.domItemStr = domItem.outerHTML;
              this.insertCursorPosition(domItem)
              // this.insertCursorPosition(this.getContentEditorFileItem(val.path,'file',val))
            }else{
              tmp.splice(this.lastTextIndex + idx * 6, 0, "<文件" + (val.newImportIdx + 1) + ">\n")
            }
          }
          this.content = tmp.join("");
        });
        if(this.isWeb&&cursorEndFlag){
            if(cursorEndFlag){
              setTimeout(()=>{
                document.execCommand('insertLineBreak');
                // const selection = window.getSelection();
                // const range = selection.getRangeAt(0);
                // // 1. 创建并插入一个稳定的 <br> 元素
                // const brElement = document.createElement('br');
                // range.insertNode(brElement);

                // // 2. 重点：新的范围应该基于已插入DOM的brElement
                // const newRange = document.createRange();
                // // 将新光标的起始点设置在 brElement 后面
                // newRange.setStartAfter(brElement);
                // newRange.collapse(true);
                // selection.removeAllRanges();
                // selection.addRange(newRange);
              },1)
            }
          }
        this.fileList.splice(this.fileList.length, 0, ...fileList)
        this.$refs.fileInput.value = ''
        console.log("uploadFiles：", this.fileList);
      },
      async uploadFileList(fileList) {
        this.loading = this.$loading.service({
          lock: true,
          text: '上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          fullscreen: true
        });
        return new Promise(async (resolve, reject) => {
          if (!fileList.length) {
            resolve(false)
            return;
          }

          let partArr = fileList.filter((val) => {
            return !val.waitUpload;
          })
          let waitUploadFileArr = fileList.filter((val) => {
            return val.waitUpload;
          })
          console.log('waitUploadFileArr.length==' + waitUploadFileArr.length);
          if (waitUploadFileArr.length) {
            let waitUploadImgList = waitUploadFileArr.filter((file) => {
              return file.fileType == 'img'
            })
            let waitUploadVideoList = waitUploadFileArr.filter((file) => {
              return file.fileType == 'video'
            })
            let waitUploadOtherList = waitUploadFileArr.filter((file) => {
              return file.fileType == 'file' || file.fileType == 'audio'
            })
            let tokenParams = {
              functionType: 2,
              targetId: localStorage.getItem("edujia:group:web:userid")
            }
            let imageSuffix = [];
            waitUploadFileArr.forEach((file) => {
              if (file.fileType == 'img') {
                // imageSuffix.push(file.file.type)
                imageSuffix.push(file.file.type.split("/")[1])
              }
            })
            if (imageSuffix.length) {
              tokenParams.imageSuffix = JSON.stringify(imageSuffix)
            }

            let videoSuffix = [];
            waitUploadFileArr.forEach((file) => {
              if (file.fileType == 'video') {
                videoSuffix.push(file.file.type.split("/")[1])
              }
            })
            if (videoSuffix.length) {
              tokenParams.videoSuffix = JSON.stringify(videoSuffix)
            }
            let mediaSuffix = [];
            waitUploadFileArr.forEach((file) => {
              if (file.fileType != 'video' && file.fileType != 'img') {
                mediaSuffix.push(file.file.name.split(".")[1])
              }
            })
            if (mediaSuffix.length) {
              tokenParams.mediaSuffix = JSON.stringify(mediaSuffix)
            }
            console.log("tokenParams:", tokenParams);
            let enResp = await this.$http.getFileUploadToken(tokenParams);
            if (enResp.code == 200) {
              let data = JSON.parse(this.$common.decrypt(enResp.data, localStorage.getItem(
                "edujia:group:web:key")))
              console.log("getFileUploadToken res:", data);
              let imageDomain = data.object.imageDomain;
              let videoDomain = data.object.videoDomain;
              let mediaDomain = data.object.mediaDomain;
              if (waitUploadImgList.length) {
                let resultArr = await qiniuService.uploadImgArr(data.object.imageToken, waitUploadImgList);
                console.log('result ==' + JSON.stringify(resultArr));
                resultArr.forEach((val, index) => {
                  fileList.forEach((file) => {
                    if (file.id == val.id) {
                      file.key = val.url.key;
                      file.url = imageDomain + val.url.key;
                    }
                  })
                })
              }
              if (waitUploadVideoList.length) {
                for (let i = 0; i < waitUploadVideoList.length; i++) {
                  let waitUploadVideo = waitUploadVideoList[i];
                  let uploadResult = await qiniuService.uploadVideo(waitUploadVideo.file, data.object
                    .videoToken[i])
                  waitUploadVideo.videoUrl = videoDomain + uploadResult.key
                  new QRCode("videoQr" + waitUploadVideo.newImportIdx, {
                    text: waitUploadVideo.videoUrl, // 需要转换为二维码的内容
                    width: 76,
                    height: 76,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                  })
                  waitUploadVideo.posterFile = await this.generateVideoQr("video" + waitUploadVideo
                    .newImportIdx);
                }
                let resultArr = await qiniuService.uploadHuashuVideoArr(data.object.videoToken,
                  waitUploadVideoList);
                console.log('result ==' + JSON.stringify(resultArr));
                resultArr.forEach((val, index) => {
                  fileList.forEach((file) => {
                    if (file.id == val.id) {
                      file.key = val.url.key;
                      file.url = videoDomain + val.url.key;
                      file.icon = this.$common.getVideoPoster(file.url);
                      file.qrPosterUrlKey = val.qrPosterUrl.key;
                      file.qrPosterUrl = imageDomain + val.qrPosterUrl.key;
                    }
                  })
                })
              }
              if (waitUploadOtherList.length) {
                let resultArr = await qiniuService.uploadImgArr(data.object.mediaToken, waitUploadOtherList);
                console.log('result ==' + JSON.stringify(resultArr));
                resultArr.map((val, index) => {
                  fileList.forEach((file) => {
                    if (file.id == val.id) {
                      file.key = val.url.key;
                      file.url = mediaDomain + val.url.key;
                      // if(file.fileType=='video'){
                      //   file.icon=this.$common.getVideoPoster(file.url);
                      // }
                    }
                  })
                })
              }
            }
          }
          console.log("uploaded fileList:", fileList);
          this.loading.close()
          resolve(fileList)
        })
      },
      //查询话术可添加的文件类型（1图片，2视频，3文件，4语音）
      //打开/预填话术窗口时预取一次，选文件前 await 同一个请求：既不重复请求，也保证限制校验用的是最新数据。
      //silent + 异常兜底：接口报错只在日志里留痕，不再在窗口刚打开时弹“系统异常，请联系客服…”，
      //查不到时保持默认全类型，不影响上传。
      qryHuashuLimit() {
        if (this.huashuLimitPromise) return this.huashuLimitPromise;
        let params = {
          speechId: this.speechId,
          labelId: this.labelId,
          id: this.huashuId ? this.huashuId : 0,
        }
        //排查用：打印本次 request 的参数
        //生产构建 terser 开了 drop_console，console 会被删掉，所以同时用 hlog 写一份到 /tmp/wminput-huashu.log
        console.log('qryHuashuLimit params=', params);
        hlog('qryHuashuLimit params=' + JSON.stringify(params));
        this.huashuLimitPromise = this.$http.qryHuashuLimit(params, {
          silent: true
        }).then((enResp) => {
          if (enResp && enResp.code == 200 && enResp.data && enResp.data.object) {
            //可上传类型，1图片，2视频，3文件，4语音
            this.canUploadType = enResp.data.object.canUploadType;
            // this.canUploadType=[2,4]
          }
          return enResp;
        }).catch((e) => {
          hlog('qryHuashuLimit 查询失败：' + (e && e.message));
          //请求本身失败（网络等）时清掉缓存，下次打开/选文件可以重试
          this.huashuLimitPromise = null;
        });
        return this.huashuLimitPromise;
      },
      //话术多媒体 提交映射
      async submitHuashuMapping() {
        return new Promise(async (resolve, reject) => {
          let mediaArray = this.fileList.map((file) => {
            let type;
            if (file.fileType == "img") {
              type = 1;
            } else if (file.fileType == "video") {
              type = 2;
            } else {
              type = 3;
            }
            let info = {
              url: file.url,
              type: type,
            }
            if (type == 2) {
              info.imageUrl = file.qrPosterUrl;
            }
            if (type == 3) {
              info.title = file.file.name;
            }
            return info
          })
          let params = {
            mediaArray: JSON.stringify(mediaArray),
          }
          let enResp = await this.$http.submitHuashuMapping(params);
          if (enResp.code == 200) {
            resolve();
          }
        })
      },
      replaceBrTags(text, replacement = '\n') {
          const brRegex =  /<br\s*[^>]*>/gi;
          return text.replace(brRegex, replacement);
      },
      replaceAll(string, search, replace) {
        return string.split(search).join(replace);
      },
      getFileIcon(fileName) {
        let icon = ""
        if (fileName.includes(".doc")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143256.png"
        } else if (fileName.includes(".txt")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143245.png"
        } else if (fileName.includes(".xls")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143214.png"
        } else if (fileName.includes(".mp3") || fileName.includes(".m4a")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114041.png"
        } else if (fileName.includes(".pdf")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114100.png"
        } else if (fileName.includes(".ppt") || fileName.includes(".pptx")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230608114321.png"
        } else {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230601152642.png"
        }
        return icon;
      },
      // 提取文件后缀的辅助函数
      getFileExtension(url) {
        const path = url.split('/');
        const fileName = path[path.length - 1];
        const parts = fileName.split('.');

        if (parts.length > 1) {
          return parts.pop();
        }

        return '';
      },
      generateEleList(text) {
        let eleList = []
        let _this = this;
        // text = this.replaceAll(text, "<分段>", "");
        const urlRegex =
          /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]\.(png|jpg|jpeg|pdf|docx|doc|dotm|xlsx|xls|mp4|mov|mp3|m4a|aac|caf|pptx|ppt|txt)/gi;
        const urls = [];
        let match;
        let lastPart = text;

        while ((match = urlRegex.exec(text)) !== null) {
          let url = match[0];
          const fileExtension = this.getFileExtension(url);

          // 只添加具有正确文件后缀的URL
          if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension ===
            'pdf' || fileExtension === 'doc' || fileExtension === 'docx' || fileExtension === 'dotm' ||
            fileExtension === 'dotx' || fileExtension === 'dotm' || fileExtension === 'txt' || fileExtension ===
            'xlsx' || fileExtension === 'xls' || fileExtension === 'mp4' || fileExtension === 'mov' || fileExtension ===
            'mp3' || fileExtension === 'm4a' || fileExtension === 'aac' || fileExtension === 'caf' || fileExtension ===
            'ppt' || fileExtension === 'pptx') {
            let tmp = lastPart.split(url);
            // console.log("tmp==",tmp[0]);
            eleList.push({
              type: "text",
              val: tmp[0],
            })
            if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
              eleList.push({
                type: "img",
                val: url,
              })
              this.imgUrlList.push(url)
            } else if (fileExtension === 'mp4') {
              eleList.push({
                type: "video",
                val: url,
              })
            } else if (fileExtension === 'mp3' || fileExtension === 'm4a') {
              let eleIdx = eleList.length;
              let tmpUrl = new URL(url);
              let fileName = tmpUrl.pathname.split('/').pop();
              let audio = new Audio();
              audio.src = url;
              audio.id = "audio" + eleIdx;
              let id = new Date().getTime();
              eleList.push({
                type: "audio",
                val: url,
                fileName: fileName,
                fileIcon: this.getFileIcon(fileName),
                id: id
              })
              audio.muted = true;
              audio.play().then(() => {
                audio.pause()
              })
              audio.muted = false;
              audio.addEventListener("loadedmetadata", () => {
                console.log("audio duration==", audio.duration);
                this.eleList.forEach((ele, idx) => {
                  if (ele.id == id) {
                    this.eleList.splice(idx, 1, {
                      type: "audio",
                      val: url,
                      fileName: fileName,
                      fileIcon: this.getFileIcon(fileName),
                      duration: audio.duration * 1000,
                    });
                  }
                })
              });
              this.audioList.push(audio)
            } else {
              let tmpUrl = new URL(url);
              const fileName = tmpUrl.pathname.split('/').pop();
              eleList.push({
                type: "file",
                val: url,
                fileName: fileName,
                fileIcon: this.getFileIcon(fileName)
              })
            }
            lastPart=tmp[1]
            // let str = ""
            // tmp.forEach((tmpItem, idx) => {
            //   if (idx) {
            //     str += tmpItem
            //   }
            // })
            // lastPart = str;
          }
        }
        eleList.push({
          type: "text",
          val: lastPart,
        })
        console.log(eleList);
        // })
        return eleList;
      },
      async initEditHuashuData(){
        //记录本次注入的序号：等待标题/媒体信息期间窗口可能又收到新的注入（新增/添加到话术），
        //旧数据不能在后面覆盖新内容（否则"添加到话术"带过来的文案会被上一次编辑的话术覆盖掉）
        const seq = this.huashuInfoSeq;
        hlog('initEditHuashuData start seq=' + seq + ' id=' + (this.editHuashuData && this.editHuashuData.id) + ' speechTextLen=' + ((this.editHuashuData && this.editHuashuData.speechText) ? this.editHuashuData.speechText.length : 0));
        this.title = this.editHuashuData.title;
        // let content = this.replaceAll(this.editHuashuData.speechText, "</标记颜色结束>", "<*/标记颜色结束>");
        let content = this.editHuashuData.speechText;
        content = this.convertColorTags(content)
        content = this.replaceHuashuBianliang(content)
        content = this.replaceAll(content, "<分段>", this.getContentEditPartItem().outerHTML);
        this.content = content;
        this.isCarryTitle = this.editHuashuData.isCarryTitle;
        let eleList = this.generateEleList(content);
        let tmpFileList = eleList.filter((val)=>{return val.type != 'text' && val.type != 'img'&&val.type != 'video'})
        let titleList=[];
        if(tmpFileList.length){
          titleList = await this.qryHuashuListTitle(tmpFileList.map((val)=>{return val.val}))
          console.log("titleList：",titleList);
        }
        if(seq !== this.huashuInfoSeq){
          return;
        }
        

        let fileList = [];
        let imgCount = 0;
        let fileCount = 0;
        let audioCount = 0;
        let videoCount = 0;
        let lastHtml = content;
        let contentHtml = "";
        eleList.forEach((ele) => {
          if (ele.type != 'text') {
            let file = {
              waitUpload: false,
            };
            if (ele.type == "img" && ele.val.includes("video.")) {
              file.newImportIdx = videoCount;
              videoCount++;
              file.fileType = "video"
              file.url = ele.val;
              file.qrPosterUrl = ele.val;
              file.videoInfo = {
                duration: 0,
                poster: ele.val
              }
              file.file = {
                type: "video"
              };
              if(this.isWeb){
                let tmp = lastHtml.split(ele.val)
                if(tmp.length>1){
                  // lastHtml = tmp.slice(1).join();
                  lastHtml=lastHtml.replace(tmp[0]+ele.val, "");
                }
                contentHtml += tmp[0]
                let domItem = this.getContentEditorFileItem(ele.val,'videoPreview')
                file.domItemStr = domItem.outerHTML;
                contentHtml += domItem.outerHTML
              }else{
                let tmp = this.content.split(ele.val)
                this.content = tmp[0] + "<视频" + videoCount + ">" + tmp[1]
              }
            } else {
              file.fileType = ele.type
              file.url = ele.val;
              
              let titleResult = titleList.find((titleVal)=>{
                return titleVal.url == ele.val
              })
              if(titleResult){
                ele.fileName = titleResult.title;
              }

              if (ele.type == "file") {
                file.newImportIdx = fileCount;
                fileCount++;
                file.icon = ele.fileIcon;
                file.name =ele.fileName;
                file.file = {
                  type: ""
                };

                if(this.isWeb){
                  let tmp = lastHtml.split(ele.val)
                  if(tmp.length>1){
                    // lastHtml = tmp.slice(1).join();
                    lastHtml=lastHtml.replace(tmp[0]+ele.val, "");
                  }
                  contentHtml += tmp[0]
                  let domItem = this.getContentEditorFileItem(ele.val,'file',ele)
                  file.domItemStr = domItem.outerHTML;
                  contentHtml += domItem.outerHTML
                }else{
                  this.content = this.content.replace(ele.val, "<文件" + fileCount + ">");
                }
              } else if (ele.type == "audio") {
                file.newImportIdx = audioCount;
                audioCount++;
                file.icon = ele.fileIcon;
                file.name = ele.fileName;
                file.file = {
                  type: ""
                };
                if(this.isWeb){
                  let tmp = lastHtml.split(ele.val)
                  if(tmp.length>1){
                    // lastHtml = tmp.slice(1).join();
                    lastHtml=lastHtml.replace(tmp[0]+ele.val, "");
                  }
                  contentHtml += tmp[0]
                  let domItem = this.getContentEditorFileItem(ele.val,'file',ele)
                  file.domItemStr = domItem.outerHTML;
                  contentHtml +=  domItem.outerHTML
                }else{
                  this.content = this.content.replace(ele.val, "<音频" + audioCount + ">");
                }
              } else {
                file.newImportIdx = imgCount;
                imgCount++;
                file.file = {
                  type: "image"
                };
                
                if(this.isWeb){
                  if(lastHtml.length){
                    let tmp = lastHtml.split(ele.val)
                    if(tmp.length>1){
                      // lastHtml = tmp.slice(1).join();
                      lastHtml=lastHtml.replace(tmp[0]+ele.val, "");
                    }
                    contentHtml += tmp[0]
                  }
                  let domItem = this.getContentEditorFileItem(ele.val,'img')
                  file.domItemStr = domItem.outerHTML;
                  contentHtml += domItem.outerHTML
                }else{
                  let tmp = this.content.split(ele.val)
                  this.content = tmp[0] + "<图片" + imgCount + ">" + tmp[1]
                }
              }
            }
            fileList.push(file)
          }else{
            contentHtml += ele.val;
            if(lastHtml&&ele.val&&lastHtml.includes(ele.val)){
              // lastHtml = lastHtml.split(ele.val).slice(1).join()
              lastHtml=lastHtml.replace(ele.val, "");
            }
          }
        })
        //旧数据已经过期（期间又打开了新增/添加到话术），后面的状态和编辑器内容都不能再写
        if(seq !== this.huashuInfoSeq){
          hlog('initEditHuashuData 放弃写入：seq=' + seq + ' now=' + this.huashuInfoSeq);
          return;
        }
        if(this.isWeb&&this.$refs.contentEditor){
            if(contentHtml.slice(-15)!='<div><br></div>'){
              contentHtml += '<div><br></div>'
            }
            this.$refs.contentEditor.innerHTML = contentHtml
            hlog('initEditHuashuData 写入编辑器 html.len=' + contentHtml.length);
        }
        this.fileList = fileList;
        this.huashuId = this.editHuashuData.id;
        let imgList = this.fileList.filter((file) => {
          return file.fileType == "img"
        })
        let videoList = this.fileList.filter((file) => {
          return file.fileType == "video"
        })
        let audioList = this.fileList.filter((file) => {
          return file.fileType == "audio"
        })
        let otherList = this.fileList.filter((file) => {
          return file.fileType != "img" && file.fileType != "video"
        })
        this.newImgCount = imgList.length;
        this.newVideoCount = videoList.length;
        this.newAudioCount = audioList.length;
        this.newFileCount = otherList.length;
      },
      //查询话术文件标题
      async qryHuashuListTitle(list){
          return new Promise(async (resolve,reject)=>{
              let params={
                  urlArray:JSON.stringify(list),
              }
              let resp = await this.$http.qryHuashuListTitle(params);
              if(resp.code == 200){
                  resolve(resp.data.array);
              }else{
                  resolve([]);
              }
          })
      },
    },
    mounted() {
      if(this.isWeb){
        let _this=this;
        this.$refs.contentEditor.focus();
        this.$refs.contentEditor.addEventListener('keydown', (event)=> {
          // 检查是否是回车键
          if (event.key === 'Enter') {
            event.preventDefault(); 
            // document.execCommand('insertHTML', false, '<br>');
             document.execCommand('insertLineBreak');
            return false;
            if(event.currentTarget.innerHTML.slice(-6)=='</div>'&&event.currentTarget.innerHTML.slice(-15)!='<div><br></div>'){
              // if(event.currentTarget.innerHTML.slice(-6)!='</div>'){
                event.preventDefault(); 
                const selection = window.getSelection();
              const range = selection.getRangeAt(0);

              // 1. 创建并插入一个稳定的 <br> 元素
              const brElement = document.createElement('br');
              range.insertNode(brElement);

              // 2. 重点：新的范围应该基于已插入DOM的brElement
              const newRange = document.createRange();
              // 将新光标的起始点设置在 brElement 后面
              newRange.setStartAfter(brElement);
              newRange.collapse(true);

              selection.removeAllRanges();
              selection.addRange(newRange);
              // }
            }
            

            // event.preventDefault();
            // const selection = window.getSelection();
            // if (selection.rangeCount === 0) return;

            // const range = selection.getRangeAt(0);
            
            // // 在处理前，先删除任何已选中的内容
            // if (!range.collapsed) {
            //   range.deleteContents();
            // }

            // // 创建要插入的 <br> 元素
            // const brElement = document.createElement('br');
            
            // // 在插入前，先记录插入点后紧邻的下一个节点（如果有的话），以便之后定位光标
            // const nextNode = range.endContainer.childNodes[range.endOffset];

            // // 将 <br> 插入到当前光标位置
            // range.insertNode(brElement);

            // // 创建一个新的范围来设置光标位置
            // const newRange = document.createRange();
            
            // // 核心修改：优先尝试将光标设置在刚插入的 <br> 之后
            // if (nextNode) {
            //   // 如果原来后面有节点，就将光标设置在 <br> 和这个节点之间
            //   newRange.setStartBefore(nextNode);
            // } else {
            //   // 如果 <br> 是父容器内的最后一个节点，则将光标设置在父容器的末尾
            //   newRange.setStart(range.endContainer, range.endContainer.childNodes.length);
            // }
            // newRange.collapse(true); // 折叠范围

            // // 清除当前选区并应用新的光标位置
            // selection.removeAllRanges();
            // selection.addRange(newRange);
          }
        });

        //禁止图片粘贴影响解析
        this.$refs.contentEditor.addEventListener("paste", function(event) {
          const clipboardData = event.clipboardData;


          if (!clipboardData || !clipboardData.items) {
            return;
          }

          // 遍历剪贴板内容
          for (let i = 0; i < clipboardData.items.length; i++) {
              const item = clipboardData.items[i];
              // 检查剪贴板项是否是图片
              if (item.type.indexOf('image') !== -1) {
                  const file = item.getAsFile();
                  if (file) {
                      // 处理图片文件
                      // handleImageFile(file);
                      event.preventDefault();
                  }
              }else if(item.type=='text/plain'){
                let newTxt = clipboardData.getData('text/plain')
                document.execCommand('insertText', false, newTxt);
                event.preventDefault();
              }
          }
          return false;
      });
      }
      
      this.contentHeight = this.pageHeight - 79 - 40 - 10;
      window.addEventListener('resize', () => {
        this.pageWidth = document.documentElement.clientWidth;
        this.pageHeight = document.documentElement.clientHeight;
        this.contentHeight = this.pageHeight - 79 - 40 - 10;
      });

      //排查用日志：窗口显示/隐藏、获得焦点时，编辑器里到底有没有内容
      document.addEventListener('visibilitychange', () => {
        hlog('visibilitychange -> ' + document.visibilityState + ' editorHTML.len=' + (this.$refs.contentEditor ? this.$refs.contentEditor.innerHTML.length : -1));
      });
      window.addEventListener('focus', () => {
        hlog('window focus editorHTML.len=' + (this.$refs.contentEditor ? this.$refs.contentEditor.innerHTML.length : -1));
      });

      if(this.isWeb&&!window.require&&localStorage.getItem("editHuashuData")){
        this.editHuashuData = JSON.parse(localStorage.getItem("editHuashuData"));
        if(this.editHuashuData.speechId){
          this.speechId=this.editHuashuData.speechId;
        }
        this.labelId=this.editHuashuData.labelId
        this.$refs.contentEditor.innerHTML = this.editHuashuData.speechText;
        setTimeout(()=>{
          this.initEditHuashuData();
          this.qryHuashuLimit();
        },1)
      }

      //兜底：如果窗口在渲染进程被重新加载过（热更新/手动刷新），主进程那次推送可能已经丢了，
      //这里主动拉一次待注入数据，保证打开窗口时内容（含剪贴板文案）一定同步
      if(window.require){
        try {
          const { ipcRenderer } = window.require('electron');
          ipcRenderer.invoke('huashuEditGetData').then((resp)=>{
            if(this._isDestroyed||this._isBeingDestroyed) return;
            const huashuInfo = resp && resp.huashuInfo;
            if(huashuInfo&&!this.editHuashuData){
              this.handleHuashuInfo(huashuInfo);
            }
          }).catch(()=>{});
        } catch (e) {}
      }

      // this.$refs.contentEditor.addEventListener("input",(val)=>{
      //   this.content += val.data
      //   console.log("change val:",val.target.getHTML());
      // })
    },
    created() {
      // if(this.$route.query.isWeb){
      //   this.isWeb = this.$route.query.isWeb;
      // }
      this.isWeb = true;

      if(window.require){
          const { ipcRenderer } = window.require('electron');
          //组件重建（热更新/路由重进）时旧实例的监听会残留在 ipcRenderer 上：
          //旧监听里访问已销毁实例的 $refs 会抛错，并中断后面监听的执行（EventEmitter 的 emit 遇异常即中断），
          //导致最新实例收不到 huashuInfo —— 表现就是打开窗口后内容（含剪贴板文案）没有同步。
          //这里先清掉旧监听，只保留当前实例的。
          ipcRenderer.removeAllListeners('huashuInfo');
          this._huashuInfoHandler = (event, resp) => {
              this.handleHuashuInfo(resp && resp.huashuInfo);
          };
          ipcRenderer.on('huashuInfo', this._huashuInfoHandler);
      }else{
        if (localStorage.getItem("editHuashuData")&&!this.isWeb) {
          this.editHuashuData = JSON.parse(localStorage.getItem("editHuashuData"));
          if(this.editHuashuData.speechId){
            this.speechId=this.editHuashuData.speechId;
          }
          this.labelId=this.editHuashuData.labelId
          setTimeout(()=>{
            this.initEditHuashuData();
            this.qryHuashuLimit();
          },1)
        }
        if(localStorage.getItem(
            "huashuValList")&&this.isWeb){
          this.huashuValList=JSON.parse(localStorage.getItem(
            "huashuValList"))
        }
      }

      // console.log("huashuEdit created...");
      
    },
    beforeDestroy() {
      //组件销毁时摘掉自己的监听，避免旧实例的监听残留（残留监听会在下次打开窗口时抛错并吞掉数据）
      if (this._huashuInfoHandler && window.require) {
        try {
          window.require('electron').ipcRenderer.removeListener('huashuInfo', this._huashuInfoHandler);
        } catch (e) {}
        this._huashuInfoHandler = null;
      }
    },
  }
</script>

<style>
img {

    -webkit-user-drag: none;


    -khtml-user-drag: none;


    -moz-user-drag: none;


    -o-user-drag: none;


    user-drag: none;

}

.el-loading-mask{
  z-index: 99999999!important;
}

.contentImgItem{
  /* width:110px;
  height: 110px; */
  width:calc(100% - 20px) !important;
  height: 110px;
  position: relative;
  background-size: 110px 110px;
  background-repeat: no-repeat;
  margin:10px;
      display: inline-block;
}

.contentImgItemImg{
  /* width: 100%;
  height: 100%; */
  width: 110px!important;
  height: 110px;
  object-fit: cover;
}

.contentVideoPrviewItem{
  width:110px;
  height: 110px;
  position: relative;
  background-size: 110px 110px;
  background-repeat: no-repeat;
  margin:10px;
}

.contentImgItemImg{
  width: 100%;
  height: 100%;
}

.contentVideoItem{
  width:110px;
  height: 110px;
  position: relative;
  margin:10px;
  background-color: #000;
}

.contentVideoItem video{
  width: 100%;
  height: 100%;
}

.contentVideoItemIcon{
  width: 44px !important;
  height: 44px !important;
  position: absolute;
  left: 50%;
  top: 50%;
  /* margin-left: -22px;
  margin-top: -22px;   */
  transform: translate(-50%,-50%);
}

.contentFileItem{
  width: 350px;
  height: 70px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin: 10px;
  position: relative;
}

.contentFileItemIcon{
  width: 39px;
  height: 39px;
  margin-left: 20px;
}

.contentFileItemLabel{
  margin-left: 14px;
  width: 255px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 16px;
  color: #3C3C3C;
}

.contentImgItemDel{
  width: 14px;
  height: 14px;
  border-radius: 14px;
  overflow: hidden;
  background-size: 14px 14px;
  background-repeat: no-repeat;
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: #fff;
}
</style>

<style scoped>
  .topCheckbox{
    margin-left: 30px;
  }

  .top {
    /* width: 100%; */
    min-width: 200px;
    height: 52px;
    color: #4a90e2;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 25px;
    position: fixed;
    right: 0;
    top: 32px;
    background-color: #fff;
    justify-content: space-between;
  }

  .top img {
    width: 20px;
    height: 20px;
    margin-left: 14px;
    margin-right: 4px;
  }

  .topL {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 25px;
  }

  .title {
    border: 0;
    padding: 0;
    outline: none;
    padding-bottom: 4px;
    width: 94.87%;
    height: 22px;
    margin-left: 2.56%;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    padding-top: 84px;
  }

  .title2{
    border: 0;
    padding: 0;
    outline: none;
    padding: 21px;
    width: calc(100% - 91px);
    height: 18px;
    margin-left: 2.56%;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    background-color: #F5F6F6;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .title3{
    margin-left: 24px;
  }

  .content {
    padding: 0;
    padding-top: 4px;
    padding-left: 8px;
    padding-right: 8px;
    width: calc(94.87% - 16px);
    margin-left: 2.56%;
    margin-top: 8px;
    font-size: 14px;
    line-height: 20px;
    color: #3c3c3c;
    min-height: 164px;
    max-height: 800px;
    overflow: scroll;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
    background-color: #F5F6F6;
  }

  

  .content2 {
    padding: 0;
    padding-top: 4px;
    padding-left: 8px;
    padding-right: 8px;
    width: calc(94.87% - 16px);
    margin-left: 2.56%;
    margin-top: 8px;
    font-size: 14px;
    line-height: 20px;
    color: #3c3c3c;
    /* min-height: 298px;
    max-height: 400px; */
    height: 298px;
    overflow: scroll;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
    background-color: #F5F6F6;
    /* 强制浏览器像处理纯文本一样处理换行，减少 div 的自动包裹 */
    white-space: pre-wrap; 
     word-break: break-all;
  }

  .content2::-webkit-scrollbar {
  display: none;
}

.no-drag {
        -webkit-user-drag: none;  /* Chrome, Safari */
        -moz-user-drag: none;     /* Firefox */
        -ms-user-drag: none;      /* IE10+ */
        user-drag: none;          /* Generic */
    }

  .bottomBar {
    background-color: #fff;
    width: 100%;
  }

  .bottomBarL {
    display: flex;
    align-items: center;
    min-width: 250px;
  }

  .bottomBarLNone {}

  .bottomBarR {
    display: flex;
    align-items: center;
    margin-left: 2.56%;
    min-width: 240px;
  }

  .addLink {
    display: flex;
    align-items: center;
    color: #4A90E2;
    font-size: 14px;
    margin-right: 12px;
  }

  .addLink img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }

  .saveBtn {
    width: 91px;
    height: 27px;
    background-color: #FB5D5C;
    color: #fff;
    font-size: 10px;
    line-height: 14px;
    font-weight: 500;
    border-radius: 4px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 保存请求进行中：置灰并禁止再次点击，避免重复提交（重复提交会被服务端判为“话术已存在”） */
  .saveBtnSaving {
    opacity: 0.6;
    pointer-events: none;
  }

  .cancelBtn{
    width: 91px;
    height: 27px;
    background-color: #fff;
    border: 1px solid #E5E5E5;
    color: #3C3C3C;
    font-size: 10px;
    line-height: 14px;
    font-weight: 500;
    border-radius: 4px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .optionTitle {
    padding-left: 2.56%;
    padding-right: 16px;
    color: #3C3C3C;
    font-size: 14px;
    line-height: 40px;
    height: 40px;
  }

  .optionItem {
    display: flex;
    align-items: center;
    margin-right: 12px;
  }

  .optionItem2 {
    display: flex;
    align-items: center;
    margin-right: 0px;
  }

  .optionItem img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }

  .optionItem div {
    font-size: 14px;
    font-weight: 400;
    color: #3C3C3C;
  }

  .list {
    display: flex;
    width: calc(94.87vw - 2.56vw);
    margin-left: 2.56%;
    flex-wrap: wrap;
    padding-bottom: 50px;
    padding-top: 4px;
  }

  .itemP {
    margin: 0 10px 10px 10px;
    position: relative;
  }

  .itemClose {
    width: 14px;
    height: 14px;
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 9999;
  }

  .item {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
  }

  .imgItem {
    object-fit: cover;
    display: block;
  }

  .fileItem {
    object-fit: cover;
    background-color: #F5F6F6;
  }

  .fileItem img {
    width: 48px;
    height: 48px;
    margin: auto;
    padding-top: 14px;
    display: block;
  }

  .fileItem div {
    width: 98px;
    height: 32px;
    margin-left: 4px;
    margin-top: 11px;
    overflow: hidden;
    font-size: 11px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
    word-break: break-all;
  }

  .videoItem {}

  .videoItem img {
    width: 110px;
    height: 110px;
    object-fit: cover;
  }

  .videoItemVideo {
    width: 276px;
    height: 276px;
    overflow: hidden;
    margin: 24px 32px 24px 32px;
  }

  .videoItemVideo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .videoPosterT {
    position: relative;
  }

  .videoPosterB {
    display: flex;
  }

  .videoPosterBL {
    width: 76px;
    height: 76px;
    margin-left: 52px;
  }

  .videoPosterBR {
    margin-left: 16px;
  }

  .videoPosterBRT {
    font-size: 24px;
    color: #3C3C3C;
    line-height: 33px;
  }

  .videoPosterBRB {
    margin-top: 4px;
    font-size: 20px;
    line-height: 28px;
    color: #999999;
  }

  .videoPoster {
    width: 340px !important;
    height: 418px !important;
    background-color: #fff;
    position: absolute;
    left: -9999px;
    top: -9999px;
  }

  .videoIcon {
    width: 88px !important;
    height: 88px !important;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -44px;
    margin-top: -44px;
  }

  .miniVideoIcon {
    width: 24px !important;
    height: 24px !important;
    margin-left: -12px;
    margin-top: -12px;
  }

  .fileLabel {
    font-size: 12px;
    color: #3C3C3C;
    text-align: center;
    margin-top: 4px;
  }

  .faceBtn{
      margin-right: 8px;
      color: #4A90E2;
      display: flex;
      align-items: center;
  }
  
  .faceBtnlbl{
      padding-left: 6px;
      margin-top: -3px;
  }

  .btnBar{
    display: flex;
    justify-content: flex-end;
  }

  .topTitle{
    color: #3C3C3C;
    font-size: 24px;
    font-weight: 500;
    padding: 24px;
    border-bottom: 1px solid #e5e5e5;
    margin-top: 20px;
  }
</style>